import { Icons } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { User } from 'modules/domain/user/types'
import { UserContact } from 'modules/domain/userContact/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'
import { BorderedItem } from 'views/components/BorderedItem/BorderedItem'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import APhone from 'views/ui/Phone/APhone'
import { BlockText, Btns, ItemText } from '../Addresses/styled'
import { EditContactModal } from './EditContactModal'

type Props = {
  refetch: () => void
  contact: UserContact
  user: User
}

export const ContactItem: FC<Props> = ({ refetch, contact, user }) => {
  const { t } = useTranslation()
  const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false)
  const [showEditModal, setShowEditModal] = useState<boolean>(false)

  const [removeProgress, removeContact] = useAProgress(
    (contactId: string) => apiClient.delete(endpoints.userContacts(user.id, contactId)),
    {
      eventName: 'removeContact',
      analyticsPayload: {
        id: contact.id,
      },
      onSuccess: refetch,
    },
  )

  return (
    <>
      <BorderedItem>
        <BlockText>
          <ItemText>
            {contact.full_name}, {contact.position}
          </ItemText>
          <APhone phone={contact.phone} isMobile={contact.is_mobile_phone} />
        </BlockText>
        <Btns>
          <AButton
            id="editСontact"
            Icon={Icons.IconEdit}
            color="secondary"
            background="none"
            onClick={() => setShowEditModal(true)}
          />
          <AButton
            id="deleteContact"
            onClick={() => setShowRemoveModal(true)}
            progress={removeProgress}
            Icon={Icons.IconDelete}
            color="secondary"
            background="none"
          />
        </Btns>
      </BorderedItem>
      {showEditModal && (
        <EditContactModal
          refetchContacts={refetch}
          setShowModal={() => setShowEditModal(false)}
          contact={contact}
          user={user}
        />
      )}

      {showRemoveModal && (
        <ASharedModal id="RemoveContactModal" size="small" onClose={() => setShowRemoveModal(false)}>
          <SharedModalTitle>{t('userContact:remove_contact')}</SharedModalTitle>
          <SharedModalContent>{t('userContact:remove_text')}</SharedModalContent>
          <ADefaultModalFooter
            progress={removeProgress}
            onClose={() => setShowRemoveModal(false)}
            onConfirm={() => removeContact(contact.id)}
          />
        </ASharedModal>
      )}
    </>
  )
}
